export default Object.freeze({
	FULL_NAME: 1,
	TODAYS_DATE: 2,
	SIGNATURE: 3,
	INITIALS: 4,
	ADD_TEXT: 5,
	CHECKMARK: 6,
	NA: 7,
	BLACK_LINE: 8,
	CIRCLE_TOOL: 9,
	TODAYS_DAY: 10,
	TODAYS_MONTH: 11,
	TODAYS_YEAR: 12,
	CROSS: 13,
	ADDRESS: 14,
});